import { ChangeDetectionStrategy,Component, inject, OnInit } from '@angular/core';
import { ApolloSandbox } from '@apollo/sandbox';

import { GraphDotnetService, graphql } from 'app/shared/graph';
import { environment } from 'environments/environment';

@Component({
    selector: 'admin-graph-explorer-page',
    imports: [],
    templateUrl: './graph-explorer-page.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './graph-explorer-page.component.scss'
})
export class GraphExplorerPageComponent implements OnInit {
    protected readonly graphDotnetService = inject(GraphDotnetService);

    ngOnInit() {
        new ApolloSandbox({
            target: '#embeddableExplorer',
            initialEndpoint: environment.endpoints.graphDotnetUrl,
            endpointIsEditable: false,
            runTelemetry: false,
            initialState: {
                document: graphql`query {
                    me {
                        email
                    }
                }`
            },
            handleRequest: (endpointUrl, options) => {
                return fetch(endpointUrl, {
                    ...options,
                    headers: {
                        ...options.headers,
                        'Authorization': `Auth0Bearer ${this.graphDotnetService.accessToken}`
                    }
                });
            }
        });
    }
}
